(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tabs"] && !Shopify.designMode) return;
  try {
    
  class BrandTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      if (!this.tabs.length) return;

      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => {
          this.stopAutoplay();
          this.activate(i, { focus: false });
        });
        tab.addEventListener('keydown', (e) => this.handleKey(e, i));
      });

      this.prevBtn = this.querySelector('[data-brand-tabs-nav="prev"]');
      this.nextBtn = this.querySelector('[data-brand-tabs-nav="next"]');
      this.prevBtn?.addEventListener('click', () => {
        this.stopAutoplay();
        this.step(-1);
      });
      this.nextBtn?.addEventListener('click', () => {
        this.stopAutoplay();
        this.step(1);
      });

      const initial = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      this.activate(initial === -1 ? 0 : initial, { focus: false });

      this.setupAutoplay();
    }

    disconnectedCallback() {
      this.clearTimer();
      if (this.io) this.io.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    setupAutoplay() {
      const enabled = this.dataset.autoplay === 'true';
      if (!enabled || this.tabs.length < 2) return;

      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (prefersReduced.matches) return;
      prefersReduced.addEventListener?.('change', (e) => {
        if (e.matches) this.stopAutoplay();
      });

      const seconds = parseFloat(this.dataset.autoplayInterval) || 6;
      this.intervalMs = Math.max(2, seconds) * 1000;
      this.autoplayActive = true;
      this.classList.add('brand-tabs--autoplay');

      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.resumeAutoplay());
      this.addEventListener('focusin', () => this.pauseAutoplay());
      this.addEventListener('focusout', (e) => {
        if (!this.contains(e.relatedTarget)) this.resumeAutoplay();
      });

      this.onVisibility = () => {
        if (document.hidden) this.pauseAutoplay();
        else this.resumeAutoplay();
      };
      document.addEventListener('visibilitychange', this.onVisibility);

      // Only run when the section is actually on-screen.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          const entry = entries[0];
          this.isVisible = entry.isIntersecting;
          if (this.isVisible) this.resumeAutoplay();
          else this.pauseAutoplay();
        }, { threshold: 0.25 });
        this.io.observe(this);
      } else {
        this.isVisible = true;
        this.startTimer();
      }
    }

    startTimer() {
      this.clearTimer();
      if (!this.autoplayActive) return;
      this.timer = window.setTimeout(() => this.step(1), this.intervalMs);
    }

    clearTimer() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    pauseAutoplay() {
      this.clearTimer();
      this.classList.add('brand-tabs--paused');
    }

    resumeAutoplay() {
      if (!this.autoplayActive) return;
      if (this.isVisible === false) return;
      this.classList.remove('brand-tabs--paused');
      this.startTimer();
    }

    stopAutoplay() {
      this.autoplayActive = false;
      this.clearTimer();
      this.classList.remove('brand-tabs--autoplay', 'brand-tabs--paused');
    }

    activate(idx, { focus = true } = {}) {
      this.activeIndex = idx;
      this.tabs.forEach((tab, i) => {
        const active = i === idx;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
        this.panels[i]?.toggleAttribute('hidden', !active);
      });
      if (focus) this.tabs[idx]?.focus();

      const active = this.tabs[idx];
      if (active) {
        const accent = active.style.getPropertyValue('--brand-accent').trim();
        if (accent) this.style.setProperty('--brand-accent', accent);
      }

      if (this.autoplayActive) this.startTimer();
    }

    step(direction) {
      const next = (this.activeIndex + direction + this.tabs.length) % this.tabs.length;
      this.activate(next, { focus: false });
    }

    handleKey(event, i) {
      const map = {
        ArrowRight: i + 1,
        ArrowLeft: i - 1,
        Home: 0,
        End: this.tabs.length - 1,
      };
      if (!(event.key in map)) return;
      this.stopAutoplay();
      event.preventDefault();
      const next = (map[event.key] + this.tabs.length) % this.tabs.length;
      this.activate(next, { focus: true });
    }
  }
  if (!customElements.get('brand-tabs')) {
    customElements.define('brand-tabs', BrandTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
